import React from 'react';

const PartnersHero = () => (
  <section className="relative">
    <div className="relative h-[300px] md:h-[400px] overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=1600&h=800&fit=crop"
        alt="Wedding venue in Malta"
        className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-[#FAF9F7]"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4">
          <p className="text-white/90 text-xs tracking-[0.3em] uppercase mb-4">
            MALTA'S FINEST WEDDING PROFESSIONALS
          </p>
          <h1
            className="text-4xl md:text-6xl text-white mb-4 tracking-tight drop-shadow-lg"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            Our Partners
          </h1>
        </div>
      </div>
    </div>

    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-8">
      <div className="w-20 h-0.5 mx-auto mb-6" style={{ backgroundColor: '#DE92A9' }}></div>
      <p className="text-[#757B7F] text-lg leading-relaxed max-w-2xl mx-auto">
        We've had the pleasure of working with Malta's most talented wedding suppliers.
        Discover trusted vendors who will help bring your dream wedding to life.
      </p>
    </div>
  </section>
);

export default PartnersHero;
